export default "__VITE_ASSET__5c8b315d__"